"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextWrapFitter = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const react_1 = require("react");
function TextWrapFitter({ children, className, render: Render = 'div', }) {
    const spanRef = (0, react_1.useRef)(null);
    const parentRef = (0, react_1.useRef)(null);
    (0, app_1.useWindowSize)({ width: true });
    (0, react_1.useEffect)(() => {
        const span = spanRef.current;
        const parent = parentRef.current;
        if (span && parent) {
            parent.style.width = 'auto';
            const parentStyle = window.getComputedStyle(parent);
            const paddingLeft = Number.parseInt(parentStyle.paddingLeft, 10);
            const paddingRight = Number.parseInt(parentStyle.paddingRight, 10);
            const spanWidth = span.offsetWidth;
            const total = spanWidth + paddingLeft + paddingRight + 1;
            parent.style.width = `${total}px`;
        }
    });
    return ((0, jsx_runtime_1.jsx)(Render, Object.assign({ className: className, ref: parentRef }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ ref: spanRef }, { children: children })) })));
}
exports.TextWrapFitter = TextWrapFitter;
